import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isIQA} from '../Authetication'



export default function IQARoutes() {


  let auth = {"token": isIQA()}

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
